
const digest = '06e3ded2e7718eb9e97944e6f37e9776d971f4edaf72c865ca23b3c37a306522';
const classes = {"wrapper":"_wrapper_1y5na_1"};
const css = `._wrapper_1y5na_1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  